import React, { useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../ui/CustomModal";
import CustomTable from "../ui/CustomTable";

import { setPidChartId } from "../applicationStatus/store";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
import { setSelectedAppStatus } from "../filter/durationFilter/store";

const DonutCharts = ({ resData, propsData }) => {
  const dispatch = useDispatch();
  const chartRef = useRef(null);
  const selector = useSelector((state: RootState) => state);
  const { ruralDetailsCount } = CustomHookForRuralDetails();

  const selectorData = useSelector((state: any) => state.time?.tabs);
  const selectorDynamicData = useSelector((state) => state?.dynamicData);
  const selectCompontData =
    selector.chartListDetails?.componentData?.ALL?.[propsData?.id];

  const totals =
    resData?.[0]?.[`total_${selectorData[1]?.title?.toLowerCase()}`] || "0";

  const year = totals;

  const approved_balance_count = propsData?.has_tab
    ? resData?.[0]?.[`approved_${selectorData[1]?.title?.toLowerCase()}`]
    : (resData?.[0] && resData?.[0][Object.keys(resData[0])[0]]) || "0";
  const rejected_balance_count = propsData?.has_tab
    ? resData?.[0]?.[`rejected_${selectorData[1]?.title?.toLowerCase()}`]
    : (resData?.[0] && resData?.[0][Object.keys(resData[0])[1]]) || "0";
  const pending_balance_count = propsData?.has_tab
    ? resData?.[0]?.[`pending_${selectorData[1]?.title?.toLowerCase()}`]
    : (resData?.[0] && resData?.[0][Object.keys(resData[0])[2]]) || "0";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const data = [
    { name: "Approved", y: Number(approved_balance_count), color: "#0BB783" },
    { name: "Rejected", y: Number(rejected_balance_count), color: "#DC2626" },
    { name: "Pending", y: Number(pending_balance_count), color: "#FDBA74" },
  ];

  // const total = data?.reduce((sum, item) => sum + item?.y, 0)
  // Shared function to draw center label
  const drawCenterText = (chart) => {
    // Remove previous label if exists
    if (chart.customYearLabel) {
      chart.customYearLabel.destroy();
    }

    const centerX = chart.plotLeft + chart.plotWidth / 2;
    const centerY = chart.plotTop + chart.plotHeight / 2;

    const yOffset = 8; // simulate margin-top by pushing it down

    chart.customYearLabel = chart.renderer
      .text(`${year}`, centerX, centerY + yOffset)
      .css({
        color: "#000",
        fontSize: "20px",
        fontWeight: "bolder",
      })
      .attr({
        align: "center",
        "text-anchor": "middle",
      })
      .add();
  };

  const selectedTab = useSelector(
    (state: any) => state.time?.tabs?.[propsData?.id]
  );
  const fetchPopupData = async (name: string) => {
    await dispatch(setSelectedAppStatus(name));
    // if (id) {
    //   await dispatch(setPidChartId(id));
    // }

    // selectedTab?.id;

    await ruralDetailsCount(selectedTab?.popup_chart_id, propsData?.id);
  };

  const options = {
    chart: {
      type: "pie",
      height: 200,
      backgroundColor: "transparent",
      // events: {
      //   load() {
      //     drawCenterText(this);
      //   },
      //   redraw() {
      //     drawCenterText(this);
      //   },
      // },
    },
    title: { text: "" },
    tooltip: {
      pointFormat: "({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        innerSize: "85%",
        dataLabels: {
          enabled: false, // disabled text and lines
        },

        point: {
          events: {
            click: function () {
              setIsModalOpen(true);
              fetchPopupData(this.name);
            },
          },
        },
      },
    },
    series: [
      {
        name: "",
        data: data,
      },
    ],
    credits: { enabled: false },
  };

  return (
    <div className="w-[203px] h-[230px] mx-auto flex items-center justify-center">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />

      <CustomModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title="Chart Detail"
        size={propsData?.size || "xl"}
      >
        <div>
          <CustomTable
            columns={
              selectorDynamicData?.[selectedTab?.popup_chart_id]?.columns
            }
            rows={selectorDynamicData[selectedTab?.popup_chart_id]?.rows}
            fetchData={selectorDynamicData[selectedTab?.popup_chart_id]}
            key={selectorDynamicData[selectedTab?.popup_chart_id]}
            applicationStatusData={fetchPopupData}
            id={selectedTab?.popup_chart_id}
            title="Chart Detail"
            hideTitle={true}
            isLoading={
              selectorDynamicData?.loaders[
                `report/chart/${selectedTab?.popup_chart_id}`
              ]
            }
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default DonutCharts;
